module.exports = __webpack_public_path__ + "img/CV.3351d1e3.svg";